import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 md:py-24 px-6 bg-brand-card" data-id="element-145">
      <div className="max-w-4xl mx-auto" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-surface rounded-2xl p-8 md:p-12 border-l-4 border-brand-accent shadow-xl relative" data-id="element-147">
          <Clock className="absolute top-8 right-8 w-12 h-12 text-brand-accent/20" aria-hidden="true" data-id="element-148" />

          <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-text uppercase mb-8" data-id="element-149">
            Resultados en Tiempo Récord
          </h2>

          <div className="font-body text-lg text-brand-muted leading-relaxed space-y-6" data-id="element-150">
            <p data-id="element-151">
              En los primeros 7 días, notarás que la{' '}
              <strong className="text-brand-text" data-id="element-152">
                "neblina mental" desaparece
              </strong>
              . Te despertarás antes que la alarma, con una claridad que no
              sentías hace años.
            </p>
            <p data-id="element-153">
              A los 21 días,{' '}
              <strong className="text-brand-text" data-id="element-154">
                tu ropa te quedará diferente
              </strong>{' '}
              y esa sensación de "morir" en el sofá a las 7 PM será cosa del
              pasado.
            </p>

            <div className="mt-8 pt-8 border-t border-brand-card" data-id="element-155">
              <p className="font-heading font-bold text-2xl md:text-3xl text-brand-accent uppercase tracking-wide" data-id="element-156">
                "Es un cambio de identidad química, no solo física."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}